import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
    /*
     * Regular Stimulus lifecycle methods
     * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
     *
     * If you intend to use this controller as a regular stimulus controller as well,
     * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
     *
     * Important:
     * By default, StimulusReflex overrides the -connect- method so make sure you
     * call super if you intend to do anything else when this controller connects.
     */
    static targets = ["hm0_output"];

    connect() {
        console.log("bc planif JS en cours ...");
        super.connect();
        
    }

    update_temps_plein(event) {
        event.preventDefault();
        if (this.isActionCableConnectionOpen()){
            console.log("CONNECTED");
            document.getElementById("ok_hidden_field").value = "";
            this.stimulate("BcPlanifications#update_temps_plein", event.currentTarget);
            console.log("Update temps plein succesfully done !");
        }else{
            console.log("STOP NOT CONNECTED");
            var element = event.currentTarget;
            element.style.backgroundColor = "#FF8B8B";
            element.style.boxShadow = "0px 1px 10px red";
        }
    }
    update_site_planif_jour(event){
        if (this.isActionCableConnectionOpen()) {
        document.getElementById("ok_hidden_field").value = "";
        this.stimulate("BcPlanifications#update_site_planif_jour", event.currentTarget);
        } else {
        console.log("STOP NOT CONNECTED");
        var element = event.currentTarget;
        element.style.backgroundColor = "#FF8B8B";
        element.style.boxShadow = "0px 1px 10px red";
        }
    }
    update_planif(event) {
        if (this.isActionCableConnectionOpen()){
            document.getElementById("ok_hidden_field").value = "";
            this.stimulate("BcPlanifications#update_planif", event.currentTarget);
    
        }else{
            console.log("STOP NOT CONNECTED");
            var element = event.currentTarget;
            element.style.backgroundColor = "#FF8B8B";
            element.style.boxShadow = "0px 1px 10px red";  
        }
    }

    update_planif_week(event) {
        if (this.isActionCableConnectionOpen()){
            this.stimulate("BcPlanifications#update_planif_week", event.currentTarget);
        }else{
            console.log("STOP NOT CONNECTED");
        }
    }

    lissage_budget(event) {
        let startDate = event.currentTarget.dataset.startDateLissage;
        let endDate = event.currentTarget.dataset.endDateLissage;
        const formattedStart = new Date(startDate).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric"
        });

        const formattedEnd = new Date(endDate).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric"
        });
        // Afficher une confirmation avant de continuer
        if (window.confirm("Êtes-vous sûr de vouloir continuer le lissage du budget du " + formattedStart + " au " + formattedEnd + " ?")) {
            
            if (this.isActionCableConnectionOpen()) {
                this.stimulate("BcPlanifications#lissage_budget", event.currentTarget);
            } else {
                console.log("STOP NOT CONNECTED");
                $('#child-loader').hide();
            }
        } else {
            $('#child-loader').hide();
            console.log("Lissage annulé par l'utilisateur.");
        }
    }


    update_tache_statut(event) {
        if (this.isActionCableConnectionOpen()){
            this.stimulate("BcPlanifications#update_tache_statut", event.currentTarget);
        }else{
            console.log("STOP NOT CONNECTED");
        }
    }

    update_debut(event) {
        if (this.isActionCableConnectionOpen()){
            this.stimulate("BcPlanifications#update_debut", event.currentTarget);
        }else{
            console.log("STOP NOT CONNECTED");
        }
    }

    update_date_de_livraison_prevue(event) {
        if (this.isActionCableConnectionOpen()){
            this.stimulate("BcPlanifications#update_date_de_livraison_prevue", event.currentTarget);
        }else{
            console.log("STOP NOT CONNECTED");
        }
    }

    update_planif_jour(event) {
        if (this.isActionCableConnectionOpen()){
            let index = 0;
            let element = $(event.target);
            if (element[0].tagName == "INPUT") {
              index = 2;
            } 
            let collab = element[0].attributes[6 + index].value
            let cr = element[0].attributes[7 + index].value
            let di = element[0].attributes[8 + index].value
            let isMonday = element[0].attributes[9 + index].value
            let isPremier = element[0].attributes[10 + index].value
            let jour = element[0].attributes[11 + index].value
            let isCr = element[0].attributes[12 + index].value
            let qte = event.target.value;

            if(isCr == 1) {
                if (di == 0) {
                    document.getElementById("update_semaine_tp-"+collab+"-"+cr).attributes[10].value = jour;
                } else {
                    document.getElementById("update_semaine_tp-"+collab+"-"+cr+"-"+di).attributes[10].value = jour;   
                }
            }

            document.getElementById("ok_hidden_field").value = "";
            
            if (isPremier == 1 && qte == 1 ) {

                let res = confirm("Voulez-vous planifer sur toute la période ?");

                if(res == true) {

                    if(di == 0) {
                        $("#update_temps_plein-"+collab+"-"+cr).click();
                    } else {
                        $("#update_temps_plein-"+collab+"-"+cr+"-"+di).click();
                    }

                } else {

                    let res2 = confirm("Voulez-vous planifier toute la semaine ?");

                    if(res2 == true) {

                        if(di == 0) {
                            $("#update_semaine_tp-"+collab+"-"+cr).click();
                        } else {
                            $("#update_semaine_tp-"+collab+"-"+cr+"-"+di).click();
                        }
                        
                    } else {
                        this.stimulate("BcPlanifications#update_planif_jour", event.currentTarget);
                    }

                }
            } else if (isMonday == 1 && qte == 1) {

                let res = confirm("Voulez-vous planifier toute la semaine ?");

                if(res == true) {

                    if(di == 0) {
                        $("#update_semaine_tp-"+collab+"-"+cr).click();
                    } else {
                        $("#update_semaine_tp-"+collab+"-"+cr+"-"+di).click();
                    }

                } else {

                    this.stimulate("BcPlanifications#update_planif_jour", event.currentTarget);
                }
            } else {

                this.stimulate("BcPlanifications#update_planif_jour", event.currentTarget);

            }
        }else{
            console.log("STOP NOT CONNECTED");
            var element = event.currentTarget;
            for (let i = 0 ; i < $(element).closest('tr').find('select.small-text').length ; i++) {
                $(element).closest('tr').find('select.small-text').eq(i).css("background-color", "#98FF98");
                $(element).closest('tr').find('select.small-text').eq(i).css("boxShadow", "0px 1px 10px green");  
            }
        }
    }

    beforeUpdatePlanif(element) {
    }

    beforeUpdateTempsPlein(element) {
        console.log("BEFORE temps_plein");
    }

    beforeUpdatePlanifWeek(element) {
        console.log("BEFORE planif_week");
    }

    beforeLissageBudget(element) {
        console.log("BEFORE lissage_budget");
    }

    beforeUpdateTacheStatut(element) {
        console.log("BEFORE update_tache_statut");
    }

    beforeUpdateSemaineTp(element) {
        console.log($("#ok_hidden_field").val());
        console.log("BEFORE semaine");
    }

    beforeUpdateTempsPleinTotaux(element) {
        console.log("BEFORE temps_plein totaux");
        console.log($("#update_temps_plein-hidden").val());
        document.getElementById("update_temps_plein-hidden").value = "";
        console.log($("#update_temps_plein-hidden").val());
    }

    beforeUpdatePlanifJour(element) {
    }

    updateSitePlanifJourHalted (element){
        console.log("STOP");
        element.style.backgroundColor = "#FF8B8B";
        element.style.boxShadow = "0px 1px 10px red";
    }

    updatePlanifWeekHalted (element){
        console.log("STOP");
        element.style.backgroundColor = "#FF8B8B";
        element.style.boxShadow = "0px 1px 10px red";
    }

    updatePlanifHalted (element){
        console.log("STOP");
        element.style.backgroundColor = "#FF8B8B";
        element.style.boxShadow = "0px 1px 10px red";
    }
    updateSitePlanifJourError(element){
        console.log("STOP");
        element.style.backgroundColor = "#FF8B8B";
        element.style.boxShadow = "0px 1px 10px red";
    }
    updatePlanifError(element) {
        console.log("STOP");
        element.style.backgroundColor = "#FF8B8B";
        element.style.boxShadow = "0px 1px 10px red";
    }

    updatePlanifWeekError(element) {
        console.log("STOP");
        element.style.backgroundColor = "#FF8B8B";
        element.style.boxShadow = "0px 1px 10px red";
    }

    updateTacheStatutError(element) {
        console.log("STOP");
        element.style.backgroundColor = "#FF8B8B";
        element.style.boxShadow = "0px 1px 10px red";
    }

    lissageBudgetError(element) {
        console.log("STOP");
        $('#child-loader').hide();
    }

    lissageBudgetHalted (element){
        console.log("STOP");
        $('#child-loader').hide();
    }

    afterUpdateSemaineTp(element) {
        let collab = $(element)[0].attributes[6].value;
        let cr = $(element)[0].attributes[8].value;
        let di = $(element)[0].attributes[9].value;
        let current_jour = $(element)[0].attributes[10].value;
        let jours = JSON.parse($(element)[0].attributes[11].value);
        let jours_semaine = []
        let current_jour_parsed = new Date(current_jour);

        while (jours[0] != current_jour) {
            jours.splice(0, 1);
        }

        for (let i = 0 ; i < jours.length ; i++) {
            if(new Date(jours[i]).getDay() == 5) {
                jours_semaine.push(jours[i]);
                break;
            } else {
                jours_semaine.push(jours[i]);
            }
        }
        console.log("HIDDEN_FIELD confirmation ===> ",$("#ok_hidden_field").val());
        if ( $("#ok_hidden_field").val() == "OK" ) {
            for (let i = 0 ; i < jours_semaine.length ; i++) {
                if (di == 0) {
                    document.getElementById(collab+"-"+jours_semaine[i]+"-"+cr).value = 1;
                    document.getElementById(collab+"-"+jours_semaine[i]+"-"+cr+"-hidden").value = 1;
                    document.getElementById(collab+"-"+jours_semaine[i]+"-"+cr).style.backgroundColor = "#98FF98";
                    document.getElementById(collab+"-"+jours_semaine[i]+"-"+cr).style.boxShadow = "0px 1px 10px green";
                } else {
                    document.getElementById(collab+"-"+jours_semaine[i]+"-"+cr+"-"+di).value = 1;
                    document.getElementById(collab+"-"+jours_semaine[i]+"-"+cr+"-"+di+"-hidden").value = 1;
                    document.getElementById(collab+"-"+jours_semaine[i]+"-"+cr+"-"+di).style.backgroundColor = "#98FF98";
                    document.getElementById(collab+"-"+jours_semaine[i]+"-"+cr+"-"+di).style.boxShadow = "0px 1px 10px green";
                }
            }
        }

        console.log("UPDATE SEMAINE DONE !");
    }

    afterUpdateTempsPlein(element) {
        let collab = $(element)[0].attributes[5].value;
        let cr = $(element)[0].attributes[6].value;
        let di = $(element)[0].attributes[7].value;
        console.log("HIDDEN_FIELD confirmation ===> ",$("#ok_hidden_field").val());
        if ( $("#ok_hidden_field").val() == "OK" ){
            for (let i = 0 ; i < $(element).closest('tr').find('select.small-text').length ; i++) {
                $(element).closest('tr').find('select.small-text')[i].value = 1;
                $(element).closest('tr').find('select.small-text').eq(i).css("background-color", "#98FF98");
                $(element).closest('tr').find('select.small-text').eq(i).css("boxShadow", "0px 1px 10px green");
                
                $(element).closest('tr').find('input.small-text')[i].value = 1;
                $(element).closest('tr').find('input.small-text').eq(i).css("background-color", "#98FF98");
                $(element).closest('tr').find('input.small-text').eq(i).css("boxShadow", "0px 1px 10px green");
            }
            if(di == 0) {
                $("#update_temps_plein_totaux-"+collab+"-"+cr).click();
            } else {
                $("#update_temps_plein_totaux-"+collab+"-"+cr+"-"+di).click();
            }
        }
    }

    afterUpdateTempsPleinTotaux(element) {
        let collab = $(element)[0].attributes[6].value;
        let cr = $(element)[0].attributes[8].value;
        let di = $(element)[0].attributes[9].value;
        console.log($(element))

        if ( $("#update_temps_plein-hidden").val() == "OK" ){
            if(di == 0) {
                $("#update_temps_plein_totaux_all-"+collab+"-"+cr).click();
            } else {
                $("#update_temps_plein_totaux_all-"+collab+"-"+cr+"-"+di).click();
            }
        }
    }
    afterUpdateSitePlanifJour(element){
        element.style.backgroundColor = "#98FF98";
        element.style.boxShadow = "0px 1px 10px green";
    }

    afterUpdatePlanifWeek(element){
        element.style.backgroundColor = "#98FF98";
        element.style.boxShadow = "0px 1px 10px green";
    }

    afterUpdateDebut(element){
        element.style.backgroundColor = "#98FF98";
        element.style.boxShadow = "0px 1px 10px green";
    }

    afterUpdateDateDeLivraisonPrevue(element){
        element.style.backgroundColor = "#98FF98";
        element.style.boxShadow = "0px 1px 10px green";
    }

    afterUpdateTacheStatut(element){
        element.style.backgroundColor = "#98FF98";
        element.style.boxShadow = "0px 1px 10px green";

        let domaine_id = $(element)[0].attributes[5].value;

        const stringIds = $("#tache-statut-to-remove-" + domaine_id + "-hidden").val();
        const arrayIds = stringIds.split(',').map(id => parseInt(id, 10));

        arrayIds.forEach(id => {
            const trElement = $("#tr-domaine-" + id);
            if (trElement.length) {
                trElement.slideUp(500, () => { 
                    console.log(`Ligne avec ID ${id} cachée avec effet.`);
                });
            } else {
                console.warn(`Aucune ligne trouvée pour ID ${id}`);
            }
        });
    }


    afterLissageBudget(element){
        console.log("done lissage");
        $('#child-loader').hide();
    }

    afterUpdatePlanif(element) {
        console.log($("#ok_hidden_field").val());
        // var collab_id = element.dataset.currentCollabId;
        // var month = element.dataset.monthNum;
        // var bdc_id = element.dataset.bdcId;
        // var current_planif_type = element.dataset.planifType;
        if ( $("#ok_hidden_field").val() == "OK" ){
            element.style.backgroundColor = "#98FF98";
            element.style.boxShadow = "0px 1px 10px green";
            $(element).attr("value", $(element).val());
            $(".nb_days_to_planif , .nb_days_to_planif_bdc").each(function(i,obj){ 
                var val = parseFloat($(obj).html());
                if (val > 0){
                    $(obj).removeClass("status-error");
                    $(obj).addClass("status-success");
                }else{
                    $(obj).removeClass("status-success");
                    $(obj).addClass("status-error");
                }
            });
            // if (bdc_id != null ) {
            //     $(document.getElementById("planif-"+collab_id+"-"+month+"-"+bdc_id+"-hidden")).attr("value", $(element).val());
            // } else if (current_planif_type != null ) {
            //     $(document.getElementById("planif-"+collab_id+"-"+month+"-"+current_planif_type+"-hidden")).attr("value", $(element).val());
            // } else {
            //     $(document.getElementById("planif-"+collab_id+"-"+month+"-conges-hidden")).attr("value", $(element).val());
            // }
        } 
        console.log("LETS GO");
    }

    afterUpdatePlanifJour(element) {
        console.log($("#ok_hidden_field").val()+"HIDDEN FIELD");
        // var collab_id = element.dataset.currentCollabId;
        // var month = element.dataset.monthNum;
        // var bdc_id = element.dataset.bdcId;
        // var current_planif_type = element.dataset.planifType;
        if ( $("#ok_hidden_field").val() == "OK" ){
            element.style.backgroundColor = "#98FF98";
            element.style.boxShadow = "0px 1px 10px green";
            $(element).attr("value", $(element).val());
            $(".nb_days_to_planif , .nb_days_to_planif_bdc").each(function(i,obj){ 
                var val = parseFloat($(obj).html());
                if (val > 0){
                    $(obj).removeClass("status-error");
                    $(obj).addClass("status-success");
                }else{
                    $(obj).removeClass("status-success");
                    $(obj).addClass("status-error");
                }
            });
            // if (bdc_id != null ) {
            //     $(document.getElementById("planif-"+collab_id+"-"+month+"-"+bdc_id+"-hidden")).attr("value", $(element).val());
            // } else if (current_planif_type != null ) {
            //     $(document.getElementById("planif-"+collab_id+"-"+month+"-"+current_planif_type+"-hidden")).attr("value", $(element).val());
            // } else {
            //     $(document.getElementById("planif-"+collab_id+"-"+month+"-conges-hidden")).attr("value", $(element).val());
            // }
        } 
        console.log("LETS GO");
    }
    //surcharge reflex callbacks
    beforeReflex(element, reflex, noop, reflexId) {
        console.log("before reflex callback in stimulus");
    }

    afterReflex(element, reflex, noop, reflexId) {
        console.log("after reflex callback in stimulus");
    }
    reflexSuccess(element, reflex, noop, reflexId) {
        console.log("reflex success callback in stimulus");
    }
    reflexError(element, reflex, error, reflexId) {
        console.log("reflex error callback in stimulus");
    }
    //////////////////////////////////////////////////////////////
    changeInputColor(event) {
    }

    get params() {
        return this.data.get("params");
    }

    get appel_ids() {
        return this.data.get("appel_ids");
    }

    get appel_id() {
        return this.data.get("appel_id");
    }

    get current_app() {
        return this.data.get("app");
    }

    get url_solution() {
        return this.data.get("url-solution");
    }
}
